
import { Component, Watch } from 'vue-property-decorator'

import { deserialise, serialise } from 'kitsu-core'
import { getRequest, patchRequest, postRequest } from '@/plugins/api-axios'
import { getURL } from '@/utils/axios'
import { unflattenArray } from '@/utils/app'

import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import ObservationMixin from '@/_mixins/observation'
import NestedDraggable from '@/components/draggableElements/nestedDraggable.vue'

@Component({
    components: { NestedDraggable },
    mixins: [ObservationMixin],
})
export default class SettingsObservationLocations extends Mixins<MixinInterface>(ObservationMixin) {
    projectUrl = process.env.VUE_APP_PROJECT_BASE_URL
    locationsInclude = 'parent&fields[location]=index,name,isActive,parent'
    get project() {
        return this.$route.params.type == 'p'
            ? this.$store.getters.project(this.$route.params.id)
            : null
    }

    // Item
    loadingLocations = false
    locations = [] as Array<any>

    async getObservationLocations() {
        if (!this.currentProjectId) {
        } else {
            try {
                this.loadingLocations = true
                const { data } = await getRequest(
                    getURL({
                        path: `locations`,
                        base: this.projectUrl,
                        params: {
                            include: this.locationsInclude,
                            skipLinks: '',
                            'filter[project]': this.currentProjectId,
                        },
                    })
                )

                const locationsDes = deserialise(data).data
                locationsDes.map((item) => (item.open = true))
                this.locations = unflattenArray(locationsDes, null)
            } finally {
                this.loadingLocations = false
            }
        }
    }

    @Watch('currentProjectId', { immediate: true })
    async updateOnProjectChange() {
        await this.getObservationLocations()
    }

    // Update Item
    updateLoadingLocations = false

    async patchLocation(payload: any) {
        const { data } = await patchRequest(
            getURL({
                path: `locations/${payload.id}`,
                base: this.projectUrl,
                params: {
                    include: this.locationsInclude,
                    skipLinks: '',
                },
            }),
            {},
            serialise('location', payload).data
        )

        return data
    }

    async updateOrder(value: any) {
        if (!value.added && !value.moved) return

        try {
            this.updateLoadingLocations = true
            const payload = {
                id: value.moved ? value.moved.element.id : value.added.element.id,
                type: value.moved ? value.moved.element.type : value.added.element.type,

                ...(value.moved && { index: value.moved.newIndex }),
                ...(value.added && { index: value.added.newIndex }),
                ...(value.added && {
                    parent: {
                        data: value.parent,
                    },
                }),
            }
            await this.patchLocation(payload)
        } catch (error) {
            await this.getObservationLocations()
        } finally {
            this.updateLoadingLocations = false
        }
    }

    async postLocation(payload: any) {
        const { data } = await postRequest(
            getURL({
                path: `locations`,
                base: this.projectUrl,
                params: {
                    include: this.locationsInclude,
                    skipLinks: '',
                },
            }),
            {},
            serialise('location', payload).data
        )

        return data
    }

    //New Item
    newItemNameRef = null as any

    newItemLoading = false
    newItemName = ''

    async createNewItem() {
        if (this.newItemName.length < 2) return
        try {
            this.newItemLoading = true

            const payload = serialise('location', {
                type: 'location',
                name: this.newItemName,
                parent: {
                    data: null,
                },
                project: {
                    data: {
                        id: this.currentProjectId,
                        type: 'project',
                    },
                },
            }).data

            const data = await postRequest(
                getURL({
                    path: `locations`,
                    base: this.projectUrl,
                    params: {
                        include: this.locationsInclude,
                        skipLinks: '',
                    },
                }),
                {},
                payload
            )
            if (data) {
                const newItem = deserialise(data.data).data
                newItem.children = []
                this.locations?.push(newItem)
                this.newItemName = ''
            }
        } finally {
            this.newItemLoading = false
        }
    }

    // Organize and search
    includeArchived = false
    @Watch('includeArchived', { immediate: false })
    async updateOnIncludeArchivedChange() {
        await this.getObservationLocations()
    }

    get isCollapsed() {
        function recursiveCheck(node) {
            if (node.open === true) {
                return true
            }

            return node.children ? node.children.some(recursiveCheck) : false
        }

        return this.locations.some(recursiveCheck)
    }

    toggleCollapsed(val: boolean) {
        function recursiveFilter(node) {
            node.open = val
            if (node.children) node.children.map(recursiveFilter)
            return node
        }
        return this.locations.map(recursiveFilter)
    }
}
